import Shelf from 'components/containers/shelf';
import { useEffect, useRef, type MouseEventHandler } from 'react';
import styles from './styles.module.scss';
import NoImage from 'assets/icons/no-image.svg';

const ObjectViewerThumbnails = ({
	objects,
	activeObjectIndex,
	handleClick,
}: Props) => {
	const activeRef = useRef<HTMLButtonElement | null>(null);

	useEffect(() => {
		activeRef.current.scrollIntoView({ inline: 'center' });
	}, [activeObjectIndex, activeRef]);
	return (
		<div className={styles.wrapper}>
			<Shelf gap="var(--spacing-micro)">
				{objects.map((object, index) => (
					<button
						aria-label={object.title}
						ref={activeObjectIndex === index ? activeRef : null}
						data-index={index}
						className={styles.button}
						disabled={activeObjectIndex === index}
						onClick={handleClick}
						key={object.objectID}
					>
						{object.image ? (
							/* eslint-disable @next/next/no-img-element */
							<img
								alt={object.imageAlt}
								src={object.image}
								className={styles.thumbnail}
							/>
						) : (
							/* eslint-enable @next/next/no-img-element */
							<NoImage className={styles.noImage} />
						)}
					</button>
				))}
			</Shelf>
		</div>
	);
};
interface Props {
	handleClick: MouseEventHandler<HTMLButtonElement>;
	activeObjectIndex: number;
	objects: any[]; //TODO object
}

export default ObjectViewerThumbnails;
